import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Hidden } from '@material-ui/core';
import withWidth from '@material-ui/core/withWidth';

import * as FeatureFlags from '../../../../feature-flags.json';
import ContrastLogo from '../../../assets/images/logoContrast.svg';
import PrimaryLogo from '../../../assets/images/primary_logo.svg';
import '../../../css/orderStatusPage/subComponents/ThankYouComponent.scss';

const Logo = FeatureFlags.OrderStatusPage.ThankYouComponent.usePrimaryLogo ? PrimaryLogo : ContrastLogo;

const logo = {
  src: Logo,
  alt: 'CoreView.header.logoAlt',
};

const ThankYouComponent = (props) => {
  const {
    orderPlaced,
    translation,
    user,
  } = props;

  return (
    <div className="thankYouBox">
      <Hidden smDown>
        <div className="thankYouComponent-logo">
          <img src={logo.src} alt={logo.alt} className="logoImage" />
        </div>
      </Hidden>
      <div>
        <div className="greeting">
          <Typography className="thankYou">
            {`${translation('OrderStatusPage.thankYou')} `}
            {
              FeatureFlags.OrderStatusPage.ThankYouComponent.useUppercaseUserName
                ? user.name.toUpperCase().split(' ')[0]
                : user.name.split(' ')[0]
            }!
          </Typography>
        </div>
        <div>
          <Typography className="currentStatus">
            {translation('OrderStatusPage.orderPlaced')}
          </Typography>
          <Typography className="receipt">
            {`${translation('OrderStatusPage.receipt')} `}{user.email}
          </Typography>
          <Typography className="thankYouComponent-orderNum">
            {`${translation('OrderStatusPage.orderNum')}: `}{orderPlaced.id}
          </Typography>
        </div>
      </div>
    </div>
  );
};

ThankYouComponent.propTypes = {
  user: PropTypes.objectOf(PropTypes.any),
  translation: PropTypes.func.isRequired,
  orderPlaced: PropTypes.objectOf(PropTypes.any),
};

ThankYouComponent.defaultProps = {
  user: null,
  orderPlaced: null,
};

export default (withWidth()(ThankYouComponent));
